export const formatTime = (locale: string, dateStr: string) => {
  const date = new Date(dateStr)
  return date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
}
